export enum RichLogSorting {
  ByTimeDescending = "ByTimeDescending",
  ByTimeAscending = "ByTimeAscending",
}
